document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.hero-event__button');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute('data-scroll-target');
  if (!targetSelector) return;

  const targetEl = document.querySelector(targetSelector);
  if (!targetEl) {
    console.warn('[Event hero] Scroll target not found:', targetSelector);
    return;
  }

  targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.giveaways__button');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute('data-scroll-target');
  if (!targetSelector) return;

  const targetEl = document.querySelector(targetSelector);
  if (!targetEl) {
    console.warn('[Event Giveaways] Scroll target not found:', targetSelector);
    return;
  }

  targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
});